import { render } from "./QuotesHolder.vue?vue&type=template&id=7413533e"
import script from "./QuotesHolder.vue?vue&type=script&lang=js"
export * from "./QuotesHolder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/hhkh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__